import { DecodedRouteParams, Route } from 'config/routes';
import { BannersByDocIdResponse } from 'utils/entities';

export interface ProjectAdBannerSourceProps {
  banners: BannersByDocIdResponse[];
  onBannerExpose?: (banner: IAd, index: number) => void;
  children: (getBanner: AdGetter) => React.ReactNode;
  source?: string;
}

export interface IAd {
  id: string;
  imageUrl: string;
  imageAlt: string;
  link: string;
  routeName: Route.ProjectPageCommercial | Route.ProjectPage;
  routeParams: Partial<DecodedRouteParams>;
  isExternalLink: boolean;
}

export type IndexedAd = IAd & { dynamicId: string; onBannerIntersection: BannerIntersectionFn } | undefined;

export type AdGetter = () => IndexedAd;

export type BannerIntersectionFn = (entry: IntersectionObserverEntry, banner: IAd, id: string) => void;

export enum ScreenType {
  Mobile,
  Desktop,
}
